module.exports = __webpack_public_path__ + "media/images/emblems/Linescio-coat_of_arms-69b684d980ca81b45e31482b05498536.svg";